module.exports = __webpack_public_path__ + "static/media/p2_2.b4648406.png";